import React from "react"
import PropTypes from "prop-types"
import AriaModal from "react-aria-modal"
import styled from "styled-components"
import { useDidMount } from "../../../utils/Hooks"
import { useIntl } from "react-intl"

const getApplicationNode = () => document.getElementById("body")

const StyledWrapper = styled.div`
  @media screen and (max-width: 595px) {
    height: 100vh;
    width: 100vw;
  }
`

const StyledInner = styled.div`
  @media screen and (max-width: 595px) {
    height: 100%;
  }

  @media screen and (min-width: 596px) {
    border-radius: 0.5rem;
  }
`

const underlayProps = {
  id: "modal-underlay"
}

const InformationModal = ({ onExit, children, underlayClickExits = false, ...props }) => {
  const intl = useIntl()
  useDidMount(() => {
    const underlayElement = document.getElementById("modal-underlay")
    const handleUnderlayClick = (event) => {
      if (event.target.id && underlayClickExits) {
        onExit()
      }
    }
    underlayElement.addEventListener("click", handleUnderlayClick)
    return () => {
      underlayElement.removeEventListener("click", handleUnderlayClick)
    }
  })

  return (
    <AriaModal
      {...props}
      underlayProps={underlayProps}
      getApplicationNode={getApplicationNode}
      underlayColor="rgba(181, 173, 166, 0.6)"
      verticallyCenter
      focusDialog
    >
      <StyledWrapper className={`relative mw-1280 pa3-ns pa0`}>
        <StyledInner className={`relative flex flex-column overflow-y-auto bg-white shadow-modal`}>
          <div className="pa1">
            <button
              className="input-reset pointer pa3 bw0 bg-white black-60 hover-black animate-all fr"
              onClick={onExit}
            >
              <img alt={intl.formatMessage({ defaultMessage: "close" })} src="/images/icn-close-modal.svg" />
            </button>
          </div>
          {children}
        </StyledInner>
      </StyledWrapper>
    </AriaModal>
  )
}

InformationModal.propTypes = {
  onExit: PropTypes.func.isRequired,
  titleText: PropTypes.string.isRequired
}

export default InformationModal
